export default {
  en: {
    newRateCode: 'New Rate Code',
    rateCode: 'Rate Code',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    includeBreakfast: 'Include Breakfast',
    yes: 'Yes',
    no: 'No',
    createRateCode: 'Create Rate Code',
    cancel: 'Cancel',
    period: 'Period',
    addPeriod: 'Add Period',
    addRoom: 'Add Room',
    createRateCodeSuccessTitle: 'Success',
    createRateCodeSuccessMessage: 'Add Rate Code Success.'
  },
  th: {
    newRateCode: 'สร้างเรท',
    rateCode: 'เรท',
    code: 'โค้ด',
    name: 'ชื่อ',
    status: 'สถานะ',
    includeBreakfast: 'รวมอาหารเช้า',
    yes: 'ใช่',
    no: 'ไม่ใช่',
    createRateCode: 'สร้างเรท',
    cancel: 'ยกเลิก',
    period: 'ช่วงเวลา',
    addPeriod: 'เพิ่มช่วงเวลา',
    addRoom: 'เพิ่มห้อง',
    createRateCodeSuccessTitle: 'สำเร็จ',
    createRateCodeSuccessMessage: 'สร้างเรทสำเร็จ'
  }
}
